<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
          <template slot-scope="{ row }" slot="readFlag">
            <el-tag :type="row.readFlag === 1 ? 'success' : 'danger'">
              {{ row.readFlag === 0 ? '未读' : '已读' }}</el-tag
            >
          </template>
          <template slot="menu" slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-view"
              v-if="permission.messagecenter_view"
              @click="clickView(scope.row)"
            >查看
            </el-button>
          </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, updateStatus} from"@/api/crmedical/notice/messagecenter";
    import {mapGetters} from "vuex";
    export default {
      data: function () {
        return {
          form: {},
          query: {},
          loading: true,
          page: {
            pageSize: 10,
            currentPage: 1,
            total: 0
          },
          selectionList: [],
          option: {
            height: 'auto',
            calcHeight: 50,
            tip: false,
            border: true,
            indexLabel:'序号',
            index: true,
            viewBtn: false,
            delBtn: false,
            editBtn: false,
            addBtn: false,
            selection: true,
            columnBtn: false,
            refreshBtn: false,
            searchMenuSpan: 4,
            searchMenuPosition:'right',
            column: [
              {
                label: "主键",
                prop: "id",
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: true,
              },
              {
                label: "消息通知人",
                prop: "notifyUserId",
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: true,
              },
              {
                label: "通知内容",
                prop: "businessInfo",
                type: 'textarea',
                maxlength: 300,
                showWordLimit: true,
                overHidden: true,
                span: 24,
                row: 4,
              },
              {
                label: "通知类型",
                prop: "messageSubType",
                type: "select",
                search: true,
                searchSpan:6,
                dataType: 'string',
                dicUrl: "/api/blade-system/dict/dictionary?code=message_sub_type",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
              },
              {
                label: "通知日期",
                prop: "notifyTime",
                type: "date",
                format: "yyyy-MM-dd HH:mm:ss",
                valueFormat: "yyyy-MM-dd HH:mm:ss",
              },

              {
                label: "状态",
                prop: "readFlag",
                type: "select",
                slot: true,
                searchSpan:6,
                addDisplay: false,
                dataType: 'number',
                search: true,
                dicUrl: 'api/blade-system/dict/dictionary?code=read_flag',
                props: { label: 'dictValue', value: 'dictKey' },
              },
              {
                label: "通知时间",
                prop: "releaseTimeRange",
                searchSpan:8,
                type: "datetimerange",
                showColumn:false,
                startPlaceholder:'开始时间',
                endPlaceholder:'结束时间',
                format: "yyyy-MM-dd HH:mm:ss",
                valueFormat: "yyyy-MM-dd HH:mm:ss",
                searchRange:true,
                hide: true,
                addDisplay: false,
                editDisplay: false,
                viewDisplay: false,
                search: true,
                rules: [{
                  required: true,
                  message: "请输入通知时间",
                  trigger: "blur"
                }]
              },

            ]
          },
          data: []
        };
      },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    viewBtn: this.vaildData(this.permission.messagecenter_view, false),
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            },
        },
        methods: {
          clickView(row){
            if(row.readFlag !== 1){
              console.log(row.notifyUserId)
              updateStatus({notifyUserId:row.notifyUserId}).then(() => {
                this.onLoad();
              }, error => {
                console.log(error);
              });
            }
          },
            rowSave(row, loading, done) {
                add(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
                update(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                  if(this.form.messageSubType){
                    this.form.messageSubType =  String(this.form.messageSubType);
                  }
                  if(this.form.readFlag !== 1){
                    console.log(this.form.notifyUserId)
                    updateStatus({notifyUserId:this.form.notifyUserId}).then(() => {
                      this.onLoad();
                    }, error => {
                      done();
                      console.log(error);
                    });
                  }

                    // getDetail({id:this.form.id}).then(({data}) => {
                    //     this.form = data;
                    //
                    // });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params,done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                 done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
          onLoad(page) {
            page = page || this.page;
            this.loading = true;
            if (this.query.releaseTimeRange) {
              this.query.timeStart = this.query.releaseTimeRange[0];
              this.query.timeEnd = this.query.releaseTimeRange[1];
              this.query.releaseTimeRange=null;
            }
            getList(
              Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
            ).then(({data}) => {
              this.page.total = data.total;
              data.records.forEach(ele=>{
                if(!ele.businessInfo){
                  return;
                }
                let str = '';
                let temObj = JSON.parse(ele.businessInfo)
                for(let key in temObj){
                  if(key=='notifyTitle'){
                      str += temObj[key] + ' '
                    }
                   if(key!='notifyTitle'){
                      str += key +":"+temObj[key] + ' '
                    }
                }
                ele.businessInfo =str;
              })
              this.data = data.records;
              this.loading = false;
              this.selectionClear();
            });
          }
        }
    };
</script>

<style>
</style>
